import React, { Component, Fragment } from "react";
import { Form, Select, Checkbox, Input, Radio, InputNumber } from "antd";
import { inject, observer } from "mobx-react";
import styles from "../index.module.less";

const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

const tailFormItemLayout = {
	wrapperCol: {
		xs: {
			span: 24,
			offset: 0
		},
		sm: {
			span: 20,
			offset: 4
		}
	}
};

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 2 }
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 22 }
	}
};

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},

	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class ImageForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll(callback);
	};

	render() {
		let imageSection = "";

		if (this.props.form.getFieldValue("insertImages") == true) {
			let searchForImageSection = "";
			let imagesToInsertSection = "";

			if (this.props.form.getFieldValue("searchForImages") == true) {
				searchForImageSection = (
					<FormItem label="Keywords to search for images">
						{this.props.form.getFieldDecorator("keywordsForImage", {
							rules: [
								{
									required: true,
									message: "Enter keywords to search for images"
								}
							]
						})(<TextArea rows={4} disabled={!this.props.ui.editing} />)}
					</FormItem>
				);
			} else {
				imagesToInsertSection = (
					<FormItem label="Image URLs to insert">
						{this.props.form.getFieldDecorator("imagesToInsert", {
							rules: [
								{
									required: true,
									message: "Please enter the URLs of images to insert"
								}
							]
						})(<TextArea rows={4} disabled={!this.props.ui.editing} />)}
					</FormItem>
				);
			}

			imageSection = (
				<Fragment>
					<FormItem>
						{this.props.form.getFieldDecorator("searchForImages", {
							// valuePropName: "checked"
						})(
							<RadioGroup disabled={!this.props.ui.editing}>
								<RadioButton value={true}>Search for Images</RadioButton>
								<RadioButton value={false}>Enter Image URLs</RadioButton>
							</RadioGroup>
							// <Checkbox disabled={!this.props.ui.editing}>
							// 	Search for Images
							// </Checkbox>
						)}
					</FormItem>
					{searchForImageSection}
					{imagesToInsertSection}
					<FormItem label="Minimum number of images">
						{this.props.form.getFieldDecorator("minImage", {
							rules: [
								{
									required: true,
									message: "Required"
								},
								{
									type: "integer",
									range: {
										min: 0
									},
									message: "Must be greater or equal to 0"
								}
							]
						})(
							<InputNumber
								min={0}
								disabled={!this.props.ui.editing}
							/>
						)}
					</FormItem>
					<FormItem label="Maximum number of images">
						{this.props.form.getFieldDecorator("maxImage", {
							rules: [
								{
									required: true,
									message: "Required"
								},
								{
									type: "integer",
									range: {
										min: 0
									},
									message: "Must be greater or equal to 0"
								}
							]
						})(
							<InputNumber
								min={0}
								disabled={!this.props.ui.editing}
							/>
						)}
					</FormItem>					
					<FormItem label="Image Position">
						{this.props.form.getFieldDecorator("imagePosition", {
							rules: [
								{
									required: true,
									message: "Please select image position"
								}
							]
						})(
							<Select style={{ width: 200 }} disabled={!this.props.ui.editing}>
								<Option value="Top">Top</Option>
								<Option value="Bottom">Bottom</Option>
								<Option value="Random">Random</Option>
							</Select>
						)}
					</FormItem>
				</Fragment>
			);
		}
		return (
			<Fragment>
				<Form layout="vertical" className={styles.rxform}>
					<FormItem>
						{this.props.form.getFieldDecorator("insertImages", {
							valuePropName: "checked"
						})(
							<Checkbox disabled={!this.props.ui.editing}>
								Insert images to your posts
							</Checkbox>
						)}
					</FormItem>
					{imageSection}
				</Form>
			</Fragment>
		);
	}
}

@inject("rootStore")
@observer
class ImageTab extends Component {
	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	onFieldsChange = changedFields => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;
		privateProjectStore.formChanged(changedFields);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;
		const stateForm = privateProjectStore.stateForm;
		return {
			insertImages: Form.createFormField(stateForm.insertImages),
			minImage: Form.createFormField(stateForm.minImage),
			maxImage: Form.createFormField(stateForm.maxImage),
			imagePosition: Form.createFormField(stateForm.imagePosition),
			keywordsForImage: Form.createFormField(stateForm.keywordsForImage),
			searchForImages: Form.createFormField(stateForm.searchForImages),
			imagesToInsert: Form.createFormField(stateForm.imagesToInsert)
		};
	};
	render() {
		const {
			rootStore: { privateProjectStore }
		} = this.props;
		const ui = privateProjectStore.ui;
		return (
			<ImageForm
				fields={this.mapPropsToFields()}
				ui={ui}
				onFieldsChange={this.onFieldsChange}
				wrappedComponentRef={internalForm => {
					this.internalForm = internalForm;
				}}
			/>
		);
	}
}

export default ImageTab;
